import * as React from "react";
const SvgHome = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M20 9v12h-6v-7h-4v7H4V9l8-6z" }));
export default SvgHome;
